import { render, staticRenderFns } from "./SearchHorse.vue?vue&type=template&id=3d890189&"
import script from "./SearchHorse.vue?vue&type=script&lang=js&"
export * from "./SearchHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports